<p>storagedetect works!</p>
